import Card from 'react-bootstrap/Card';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormSelect } from '@coreui/react';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';




const urlRouter = '/users';
const urlApi = '/users';

export async function LoaderUsersView({ params }) {
    let res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => {
        return response;
    });
    return res;
};


const UsersView = () => {
    const { data } = useLoaderData();
    return (<>
        {/* {(data.manager == undefined)&& <Alert variant="danger">Увага! Контрагент не має вказаного менеджера.</Alert>}
        {(data.user == undefined)&& <Alert variant="danger">Увага! Контрагент не має вказаного користувача.</Alert>} */}

        <Card>
            <Card.Header>
                <div className="row">
                    <div className="col-10">
                        <h2>{data.username}</h2>
                    </div>
                    <div className="col-2 d-flex justify-content-end"> 
                        <Link to={`${urlRouter}/update/${data.id}`}><CButton color="dark" variant="outline" title="Редагувати контрагента">Редагувати <CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>
                    </div>
                </div>

            </Card.Header>
            <Card.Body>
            {(data.mediaObjects != undefined && data.mediaObjects.length > 0) && <img src={process.env.REACT_APP_SERVER_URL + data.mediaObjects[0].contentUrl} alt="blog-image" height={300} className='m-5' />}
                <Table striped>
                    <tbody>
                        {(data.firstName != undefined) && <tr> <th>Ім'я</th> <td>{data.firstName}</td> </tr> }
                        {( data.lastName != undefined) && <tr> <th>Прізвище</th> <td>{data.lastName}</td> </tr> }
                        {( data.email != undefined) && <tr> <th>E-mail</th> <td>{data.email}</td> </tr> }
                        {( data.phone != undefined) && <tr> <th>Телефон</th> <td>{data.phone}</td> </tr> }
                        {( data.telegram != undefined) && <tr> <th>Telegram</th> <td>{data.telegram}</td> </tr> }
                        {( data.viber != undefined) && <tr> <th>Viber</th> <td>{data.viber}</td> </tr> }
                        {( data.workSchedule != undefined) && <tr> <th>Графік роботи</th> <td>{data.workSchedule}</td> </tr> }
                        {( data.lastLogin != undefined) && <tr> <th>Останній логін</th> <td>{data.lastLogin}</td> </tr> }
                        {( data.roles != undefined) && <tr> <th>Ролі</th> <td>
                            <ul>
                                {data.roles.map((r)=>(
                                    <li>{r}</li>
                                ))}
                            </ul>
                        </td> </tr> }
                        {( data.accounts != undefined) && <tr> <th>Контрагенти</th> <td>
                            <ul>
                                {data.accounts.map((a)=>(
                                    <li><Link to={`/accounts/${a.id}`} target='_blank'>{a.name}</Link></li>
                                ))}
                            </ul>
                        </td> </tr> }
                    </tbody>
                </Table>
                
            </Card.Body>
        </Card>
        <hr/>
        {(data != undefined  && data.user != undefined) &&
            <Alert variant="success">
                <Alert.Heading>Користувач {data.user.username}</Alert.Heading>
                <hr/>
                <p>
                    Заходьте в наш кабінет<br/>
                    https://cabinet.td-kramar.com/<br/>
                    Ця платформа дає можливість:<br/>
                    - переглядати інформацію про поточні акції і промо<br/>
                    - переглядати весь діючий асортимент<br/>
                    - оформити замовлення в онлайн режимі<br/>
                    - переглянути акт звірки <br/>
                    - переглядати історію замовлень і здійснювати повторне замовлення<br/> 
                </p>
                <hr/>
                <Alert.Link href={`/users/${data.user.id}`} target="_blanck">Редагуати користувача</Alert.Link>
            </Alert>
                        
        }
        
    </>);
}

export default UsersView;